export const isHTML = (src) =>
  src && typeof src === "string" && src?.includes("http");
